define([
	"csi/def/ActionFactory",
	"csi/heading/AttributeAction",
	"csi/xml"
], function(ActionFactory,AttributeAction,xml) {

	return ActionFactory.declare("RefEdit", AttributeAction, {
		constructor: function(obj) {
			this.m_id = "RefEdit";
			this.classController = this.classController || "csi.heading.RefFilterController";
			this.setBaseRights(xml.RIGHT_WRITE);
			this.dependencyPaths = ["Child:Operands/Child:DataPointContainer"]
		}
	});
});